import 'rxjs/add/operator/map';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Events } from 'ionic-angular';
import { Injectable } from '@angular/core';

import { SessionProvider } from '../session/session';

declare let process: any;
const env = process.env.IONIC_ENV;

console.log('ENVIRONMENT', env);

export enum ServerEnvironment {
  Beta = 'beta',
  Staging = 'staging',
  Prod = 'prod',
}

@Injectable()
export class EnvironmentProvider {
  private static readonly SERVER_ENVIRONMENT_KEY = 'SERVER_ENVIRONMENT';

  serverEnvironment$: BehaviorSubject<ServerEnvironment> = new BehaviorSubject(
    this.defaultServerEnvironment()
  );

  constructor(private session: SessionProvider, private events: Events) {
    this.retrieveStoredServerEnvironment();

    // Reset the server environment after login events since local storage may have been cleared
    this.events.subscribe('userDidLogout', () => {
      this.session.set(
        EnvironmentProvider.SERVER_ENVIRONMENT_KEY,
        this.serverEnvironment$.value
      );
    });
    this.events.subscribe('userDidLogin', () => {
      this.session.set(
        EnvironmentProvider.SERVER_ENVIRONMENT_KEY,
        this.serverEnvironment$.value
      );
    });
  }

  // Environment Management

  isServerBeta() {
    return this.serverEnvironment$.value === ServerEnvironment.Beta;
  }

  isServerStaging() {
    return this.serverEnvironment$.value === ServerEnvironment.Staging;
  }

  isServerProd() {
    return this.serverEnvironment$.value === ServerEnvironment.Prod;
  }

  serverVars(): ServerVars {
    if (this.isServerBeta()) {
      return betaServer;
    } else if (this.isServerStaging()) {
      return stagingServer;
    } else {
      return prodServer;
    }
  }

  switchServer(env: ServerEnvironment) {
    return this.session
      .set(EnvironmentProvider.SERVER_ENVIRONMENT_KEY, env)
      .then(() => {
        this.serverEnvironment$.next(env);
      });
  }

  private defaultServerEnvironment(): ServerEnvironment {
    return env === 'prod' ? ServerEnvironment.Prod : ServerEnvironment.Beta;
  }

  private retrieveStoredServerEnvironment() {
    return this.session
      .get(EnvironmentProvider.SERVER_ENVIRONMENT_KEY)
      .then((value?: ServerEnvironment) => {
        this.serverEnvironment$.next(value || this.defaultServerEnvironment());
      });
  }
}

// Environment Declarations

export interface ServerVars {
  readonly apiEndpoint: string;
  readonly opsEndpoint: string;
  readonly environmentName: string;
  readonly gaId: string;
  readonly fbAppId: number;
  readonly shareUrl;
  readonly stripePublishableKey;
}

export const betaServer: ServerVars = {
  apiEndpoint: 'https://api.beta.startyoshi.com/v0',
  opsEndpoint: 'https://ops.beta.startyoshi.com/v0',
  shareUrl: 'http://api.beta.startyoshi.com/users/',
  environmentName: 'Beta',
  gaId: 'UA-62595537-5',
  stripePublishableKey: 'pk_test_HcrdetnFsWge0pK6z1g78ls2',
  fbAppId: 942555735798943,
};

export const stagingServer: ServerVars = {
  apiEndpoint: 'https://api.staging.startyoshi.com/v0',
  opsEndpoint: 'https://ops.staging.startyoshi.com/v0',
  shareUrl: 'http://www.staging.startyoshi.com/users/',
  environmentName: 'Staging',
  gaId: 'UA-62595537-5',
  stripePublishableKey: 'pk_test_HcrdetnFsWge0pK6z1g78ls2',
  fbAppId: 942555735798943,
};

export const prodServer: ServerVars = {
  apiEndpoint: 'https://api.startyoshi.com/v0',
  opsEndpoint: 'https://ops.startyoshi.com/v0',
  environmentName: 'Production',
  shareUrl: 'http://www.startyoshi.com/users/',
  gaId: 'UA-62595537-5',
  stripePublishableKey: 'pk_live_TsPI4HEiJ0TNO2Zbhw6iSS12',
  fbAppId: 942555735798943,
};



// WEBPACK FOOTER //
// ./src/providers/environment/environment.ts